<template>
  <div class="feature-row">
    <div class="search-row">
      <div class="search-top-row">
        <div class="left-part"></div>
        <div class="right-part">
          <slot></slot>
        </div>
      </div>
      <div class="search-bottom-row">
        <el-select v-model="queryForm.produceSupplierId" placeholder="选择供应商" filterable clearable @change="handleFilter">
          <el-option v-for="item in supplierList" :label="item.supplierName" :value="item.supplierId" :key="item.supplierId" />
        </el-select>
        <el-select v-model="queryForm.entityId" placeholder="选择工厂" clearable filterable @change="handleFilter">
          <el-option
            v-for="item in entityList"
            :label="item.entityCode + '-' + item.entityName"
            :value="item.entityId"
            :key="item.entityId"
          />
        </el-select>
          <el-cascader
            v-model="checkValue"
            :options="brandList"
            clearable
            :props="{ expandTrigger: 'hover',label:'abiBrandDisplayName',value:'abiBrandId'}"
            @change="handleChange"></el-cascader>
        <!-- <el-select v-model="queryForm.abiBrandId" placeholder="选择品牌" clearable filterable @change="handleFilter">
          <el-option v-for="item in brandList" :label="item.abiBrandName" :value="item.abiBrandId" :key="item.abiBrandId" />
        </el-select> -->

        <!-- <el-select v-model="queryForm.categoryId" placeholder="选择分类" clearable v-if="!isPrinting">
          <el-option
            v-for="item in categoryList"
            :label="item.categoryName"
            :value="item.categoryId"
            :key="item.categoryId"
          />
        </el-select>-->
        <el-select v-model="queryForm.channel" placeholder="选择渠道" clearable @change="handleFilter">
          <el-option v-for="item in channelList" :label="item.channelName" :value="item.channelName" :key="item.channelId" />
        </el-select>

        <el-select
          v-model="queryForm.isPreOrder"
          placeholder="是否有现货"
          filterable
          clearable
          @change="handleFilter"
          v-if="pageName != 'menuFavourite'"
        >
          <el-option label="有现货" :value="1" />
          <el-option label="无现货" :value="0" />
        </el-select>
        <el-select
          v-model="queryForm.teamOrderStatus"
          placeholder="拼单状态"
          filterable
          clearable
          @change="handleFilter"
          v-if="pageName != 'menuFavourite'"
        >
          <!-- <el-option label="等待拼单" :value="1" /> -->
          <el-option label="拼单中" :value="2" />
          <!-- <el-option label="已拼单" :value="3" /> -->
        </el-select>
        <!-- <el-select v-model="queryForm.factoryMOQ" placeholder="起订量" filterable clearable>
          <el-option v-for="FactoryMOQ in FactoryMOQList" :key="FactoryMOQ.key" :label="FactoryMOQ.value" :value="FactoryMOQ.value"></el-option>
        </el-select>-->
        <div class="section">
          <span class="search-text">价格区间:</span>
          <el-popover trigger="manual" v-model="price">
            <div style="width:100%;display:flex;justify-content: space-around">
              <el-button type="text" size="mini" @click="resetPrice" style="padding:0 18px">清空</el-button>
              <el-button type="text" size="mini" @click="handleFilter" style="padding:0 18px">搜索</el-button>
            </div>
            <span slot="reference">
              <el-input
                v-model="queryForm.minPrice"
                class="price-input"
                @focus="showPrice"
                @input="showPrice"
                @blur="price = false"
                @keyup.native="minNumber"
              ></el-input>
              <span class="search-text">至</span>
              <el-input
                v-model="queryForm.maxPrice"
                class="price-input"
                @focus="showPrice"
                @input="showPrice"
                @blur="price = false"
                @keyup.native="maxNumber"
              ></el-input>
            </span>
          </el-popover>
          <span class="search-text" style="margin-left:30px" v-if="pageName != 'menuFavourite'">起订量:</span>
          <el-popover trigger="manual" v-if="pageName != 'menuFavourite'" v-model="factoryMOQ">
            <div style="width:100%;display:flex;justify-content: space-around">
              <el-button size="mini" type="text" @click="resetFactoryMOQ" style="padding:0 18px">清空</el-button>
              <el-button type="text" size="mini" @click="handleFilter" style="padding:0 18px">搜索</el-button>
            </div>
            <span slot="reference">
              <el-input
                v-model="queryForm.pocmFactoryMOQBegin"
                class="price-input"
                @focus="showFactoryMOQ"
                @input="showFactoryMOQ"
                @blur="factoryMOQ = false"
                @keyup.native="pocmFactoryMOQBegin"
              ></el-input>
              <span class="search-text">至</span>
              <el-input
                v-model="queryForm.pocmFactoryMOQEnd"
                class="price-input"
                @focus="showFactoryMOQ"
                @input="showFactoryMOQ"
                @blur="factoryMOQ = false"
                @keyup.native="pocmFactoryMOQEnd"
              ></el-input>
            </span>
          </el-popover>

          <el-checkbox
            v-model="queryForm.isNewItem"
            style="margin-left:20px"
            @change="handleFilter"
            v-if="pageName != 'menuFavourite'"
          >近三个月上架新品</el-checkbox>
        </div>
        <div style="width:200px;height:20px" v-if="pageName === 'menuFavourite'"></div>
        <div style="align-self:flex-end">
          <el-input v-model="queryForm.keyword" class="search-input" placeholder="输入名称或编码搜索">
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-button type="danger" class="btn-red" @click="handleFilter">搜索</el-button>
        </div>
        <div style="width:100%;padding-top:10px" v-if="pageName != 'menuFavourite'">
          <span
            class="sort"
            :class="{'sort-selected': queryForm.orderCol === sortItem.value, 'sort-selected-desc': queryForm.orderMethod === 'desc' && queryForm.orderCol === sortItem.value, 'sort-selected-asc': queryForm.orderMethod === 'asc' && queryForm.orderCol === sortItem.value}"
            v-for="sortItem,index in sortConditionList"
            :key="index"
            @click="sort(sortItem.value)"
          >
            <el-tooltip
              v-if="queryForm.orderCol === sortItem.value"
              class="item"
              effect="dark"
              :content="queryForm.orderCol === sortItem.value ? queryForm.orderMethod === 'desc'? '切换成由低到高排序' : '切换成由高到低排序' : ''"
              placement="top"
            >
              <span>{{sortItem.key}}</span>
            </el-tooltip>
            <span v-else>{{sortItem.key}}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseApi from '@/api/base'
export default {
  name: 'SearchRow',
  props: {
    pageName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      factoryMOQ: false,
      price: false,
      brandList: [],
      categoryList: [],
      channelList: [],
      supplierList: [],
      entityList: [],
      checkValue:null,
      queryForm: {
        isPreOrder: '',
        abiBrandId: '',
        channel: '',
        categoryId: '',
        produceSupplierId: '',
        keyword: '',
        minPrice: '',
        maxPrice: '',
        entityId: '',
        teamOrderStatus: '',
        factoryMOQ: '',
        orderCol: '',
        orderMethod: 'asc',
        pocmFactoryMOQBegin: '',
        pocmFactoryMOQEnd: '',
        isNewItem: false
      },
      abiBrandId: '',
      FactoryMOQList: [],
      sortConditionList: [
        { key: '销量', value: 'sold_qty' },
        { key: '质量评分', value: 'quality_score' },
        { key: '美观评分', value: 'appearance_score' }
      ]
    }
  },
  computed: {
    isPrinting () {
      return (
        this.$route.name === 'printing-favourite' ||
        this.$route.name === 'printing-list'
      )
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      // this.getBrand()
      this.getSubBrand()
      this.getCategory()
      this.getChannel()
      this.getSupplier()
      this.getEntity()
      // this.getFactoryMOQ()
    },
    // 工厂
    getEntity () {
      baseApi.getUserCompany().then(res => {
        if (res.data.resultCode === '0') {
          this.entityList = res.data.resultData.companyEntityList
        }
      })
    },
    handleChange(e){
     if(e[1]===0){
      this.queryForm.abiBrandId=e[0]
     }else{
      this.queryForm.abiBrandId=e[1]
     }
     this.$emit('handleFilter', this.queryForm)
    },
    // 品牌
    getBrand () {
      baseApi.getBrand().then(res => {
        if (res.data.resultCode === '0') {
          this.brandList = res.data.resultData.brandList
        }
      })
    },
    //子品牌
    getSubBrand () {
      baseApi.getSubBrand().then(res => {
        if (res.data.resultCode === '0') {
          let data=res.data.resultData.brandVOList
            data.forEach(item=>{
            item.subAbiBrandList.unshift({abiBrandId:0,abiBrandDisplayName:'全部',})
            this.brandList.push({
              abiBrandId:item.parentAbiBrand.abiBrandId,
              abiBrandDisplayName:item.parentAbiBrand.abiBrandDisplayName,
              children:[,...item.subAbiBrandList]
            })
          })
        }
      })
    },
    // 分类
    getCategory () {
      baseApi.getCategory().then(res => {
        if (res.data.resultCode === '0') {
          this.categoryList = res.data.resultData.categoryList
        }
      })
    },
    // 渠道
    getChannel () {
      baseApi.getChannel().then(res => {
        if (res.data.resultCode === '0') {
          this.channelList = res.data.resultData.baseChannelList
        }
      })
    },
    // 供应商
    getSupplier () {
      baseApi.getProduceSupplier().then(res => {
        if (res.data.resultCode === '0') {
          this.supplierList = res.data.resultData.baseLogisticsSupplierList
        }
      })
    },
    // 起订量
    // getFactoryMOQ () {
    //   baseApi.getDictData({ name: 'pocmFactoryMOQScopeMap' }).then(res => {
    //     if (res.data.resultCode === '0') {
    //       this.FactoryMOQList = res.data.resultData.pocmFactoryMOQScopeMap
    //     }
    //   })
    // },
    // 搜索
    handleFilter () {
      if (this.queryForm.minPrice && this.queryForm.maxPrice && Number(this.queryForm.maxPrice) < Number(this.queryForm.minPrice)) {
        this.$message.error('请正确输入价格区间数值')
        return
      }
      if (this.queryForm.pocmFactoryMOQBegin && this.queryForm.pocmFactoryMOQEnd && Number(this.queryForm.pocmFactoryMOQEnd) < Number(this.queryForm.pocmFactoryMOQBegin)) {
        this.$message.error('请正确输入起订量区间数值')
        return
      }
      this.$emit('handleFilter', this.queryForm)
    },
    minNumber () {
      // eslint-disable-next-line no-useless-escape
      this.queryForm.minPrice = this.queryForm.minPrice.replace(/[^\.\d]/g, '').replace('.', '')
    },
    maxNumber () {
      // eslint-disable-next-line no-useless-escape
      this.queryForm.maxPrice = this.queryForm.maxPrice.replace(/[^\.\d]/g, '').replace('.', '')
    },
    pocmFactoryMOQBegin () {
      // eslint-disable-next-line no-useless-escape
      this.queryForm.pocmFactoryMOQBegin = this.queryForm.pocmFactoryMOQBegin.replace(/[^\.\d]/g, '').replace('.', '')
    },
    pocmFactoryMOQEnd () {
      // eslint-disable-next-line no-useless-escape
      this.queryForm.pocmFactoryMOQEnd = this.queryForm.pocmFactoryMOQEnd.replace(/[^\.\d]/g, '').replace('.', '')
    },
    showPrice () {
      (this.queryForm.minPrice || this.queryForm.maxPrice) ? this.price = true : this.price = false
    },
    showFactoryMOQ () {
      (this.queryForm.pocmFactoryMOQBegin || this.queryForm.pocmFactoryMOQEnd) ? this.factoryMOQ = true : this.factoryMOQ = false
    },
    resetPrice () {
      this.queryForm.minPrice = undefined
      this.queryForm.maxPrice = undefined
      this.handleFilter()
    },
    resetFactoryMOQ () {
      this.queryForm.pocmFactoryMOQBegin = undefined
      this.queryForm.pocmFactoryMOQEnd = undefined
      this.handleFilter()
    },
    sort (sortMode) {
      if (this.queryForm.orderCol !== sortMode) {
        this.queryForm.orderMethod = 'asc'
      }
      if (this.queryForm.orderMethod === 'asc') {
        this.queryForm.orderMethod = 'desc'
      } else {
        this.queryForm.orderMethod = 'asc'
      }
      this.queryForm.orderCol = sortMode
      this.$emit('handleFilter', this.queryForm)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  border-radius: 8px;
  border-color: #eaeaea;
}
.el-button {
  border-radius: 6px;
}
::v-deep .el-input__icon {
  line-height: 36px;
}
.search-row {
  margin-bottom: $content-middle;
  line-height: 36px;
  .search-top-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: $content-middle;
    .left-part {
      font-weight: bold;
    }
  }
  .search-input.el-input {
    width: 180px;
    height: 36px;
    margin-right: $content-middle;
    input::-webkit-input-placeholder {
      color: #000;
    }
  }
  .price-input {
    width: 120px;

    ::v-deep .el-input__inner {
      padding: 0 5px;
      text-align: center;
    }
    &::v-deep .el-input-number__decrease,
    &::v-deep .el-input-number__increase {
      display: none;
    }
  }
  .search-text {
    font-size: $font-12;
    display: inline-block;
    height: 34px;
    padding: 0 5px;
  }
}
.search-bottom-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.el-select {
  width: 15%;
  height: 36px;
  margin-bottom: 20px;
}
.el-button {
  height: 36px;
  margin-left: 10px;
}
.right-part {
  display: flex;
}
.feature-row {
  margin-bottom: $content-middle;
}
.sort {
  margin: 0 35px 0 5px;
  cursor: pointer;
  &:last-child {
    margin-right: 0px;
  }
  padding: 3px;
  // font-weight: bold;
  position: relative;
  &::before {
    content: '';
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #d0d1d4;
    border-radius: 2px;
    position: absolute;
    right: -16px;
    top: -2px;
  }
  &::after {
    content: '';
    width: 0;
    height: 0;
    border-top: 6px solid #d0d1d4;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-radius: 2px;
    position: absolute;
    right: -16px;
    top: 12px;
  }
}
.sort-selected {
  color: #c8102d;
  padding: 3px;
  font-weight: bold;
  position: relative;
  &::before {
    content: '';
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #d0d1d4;
    border-radius: 2px;
    position: absolute;
    right: -16px;
    top: -2px;
  }
  &::after {
    content: '';
    width: 0;
    height: 0;
    border-top: 6px solid #c8102d;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-radius: 2px;
    position: absolute;
    right: -16px;
    top: 12px;
  }
}
.sort-selected-desc {
  &::before {
    content: '';
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #d0d1d4;
    border-radius: 2px;
    position: absolute;
    right: -16px;
    top: -2px;
  }
  &::after {
    content: '';
    width: 0;
    height: 0;
    border-top: 6px solid #c8102d;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-radius: 2px;
    position: absolute;
    right: -16px;
    top: 12px;
  }
}
.sort-selected-asc {
  &::before {
    content: '';
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #c8102d;
    border-radius: 2px;
    position: absolute;
    right: -16px;
    top: -2px;
  }
  &::after {
    content: '';
    width: 0;
    height: 0;
    border-top: 6px solid #d0d1d4;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid transparent;

    border-radius: 2px;
    position: absolute;
    right: -16px;
    top: 12px;
  }
}
</style>
<style lang="scss" scope>
.el-popover {
  padding: 0;
  left: 480px;
}
</style>
